module.exports = __webpack_public_path__ + "img/web-P4-3-4.2f950a9c.png";